import { render, staticRenderFns } from "./NotificationFooter.vue?vue&type=template&id=3c85a857&scoped=true&"
import script from "./NotificationFooter.vue?vue&type=script&lang=js&"
export * from "./NotificationFooter.vue?vue&type=script&lang=js&"
import style0 from "./NotificationFooter.vue?vue&type=style&index=0&id=3c85a857&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85a857",
  null
  
)

export default component.exports